module.exports = __webpack_public_path__ + "media/images/img_house_replacement-295fb36a05aa4a31738b324297442e59.png";